import { NudgeAction } from "./types";

const KNOWN_MECHANISMS = new Set(["slide-in", "toast", "modal", "inline-banner", "coach-mark"]);
const KNOWN_TONES = new Set(["success", "error", "info"]);
const KNOWN_IMAGES = new Set(["questioning", "phone"]);
const KNOWN_CTA_TYPES = new Set([
  "url",
  "tel",
  "sms",
  "open_chat",
  "server_action",
  "anchor",
]);

const validateForwardCompat = (n: NudgeAction): void => {
  if (!KNOWN_MECHANISMS.has(n.mechanism)) {
    console.warn(`[intent] unknown mechanism on push`, n.mechanism, `id=${n.id}`);
  }
  if (n.tone && !KNOWN_TONES.has(n.tone)) {
    console.warn(`[intent] unknown tone on push`, n.tone, `id=${n.id}`);
  }
  if (n.image && !KNOWN_IMAGES.has(n.image)) {
    console.warn(`[intent] unknown image on push`, n.image, `id=${n.id}`);
  }
  const ctaType = n.cta?.action?.type as string | undefined;
  if (ctaType && !KNOWN_CTA_TYPES.has(ctaType)) {
    console.warn(`[intent] unknown cta action.type on push`, ctaType, `id=${n.id}`);
  }
};

const nudges = new Map<string, NudgeAction>();
const listeners = new Set<() => void>();
let activeNudge: NudgeAction | null = null;

const isExpired = (n: NudgeAction): boolean =>
  typeof n.expires_at === "number" && n.expires_at < Date.now();

const recomputeActive = (): void => {
  let best: NudgeAction | null = null;
  nudges.forEach((n) => {
    if (isExpired(n)) return;
    if (!best || n.priority > best.priority) best = n;
  });
  activeNudge = best;
};

const pruneExpired = (): void => {
  const expired: string[] = [];
  nudges.forEach((n, id) => {
    if (isExpired(n)) expired.push(id);
  });
  expired.forEach((id) => nudges.delete(id));
};

const notify = (): void => {
  listeners.forEach((l) => l());
};

export const NudgeStore = {
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  getSnapshot(): NudgeAction | null {
    return activeNudge;
  },
  push(nudge: NudgeAction): void {
    validateForwardCompat(nudge);
    pruneExpired();
    nudges.set(nudge.id, nudge);
    recomputeActive();
    notify();
  },
  dismiss(id: string): void {
    if (!nudges.delete(id)) return;
    recomputeActive();
    notify();
  },
  clear(): void {
    nudges.clear();
    activeNudge = null;
    notify();
  },
};
